import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { formatDate } from '../paymentNormalizer';

export default function PaymentActivityTimeline({ payment }) {
  const events = [];

  if (payment?.createdAt) {
    events.push({
      id: 'created',
      date: payment.createdAt,
      title: 'Pago creado',
      description: payment.createdBy ? `Registrado por ${payment.createdBy}` : '',
    });
  }

  (payment?.receipt?.items || []).forEach((receipt) => {
    if (!receipt.createdAt && !receipt.date) return;
    events.push({
      id: `receipt-${receipt.id || receipt.number}`,
      date: receipt.createdAt || receipt.date,
      title: 'Recibo agregado',
      description: receipt.number ? `Recibo #${receipt.number}` : '',
    });
  });

  (payment?.methods || []).forEach((method) => {
    (method.attachments || []).forEach((attachment) => {
      if (!attachment.raw?.createdAt && !attachment.raw?.created_at) return;
      events.push({
        id: `attachment-${attachment.id}`,
        date: attachment.raw.createdAt || attachment.raw.created_at,
        title: 'Comprobante agregado',
        description: attachment.name,
      });
    });
  });

  (payment?.corrections || []).forEach((correction) => {
    events.push({
      id: `correction-${correction.id || correction.corrected_at}`,
      date: correction.corrected_at,
      title: 'Datos del pago corregidos',
      description: [
        correction.corrected_by ? `Por ${correction.corrected_by}` : '',
        correction.reason,
      ].filter(Boolean).join(' · '),
    });
  });

  if (events.length === 0) return null;

  events.sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Actividad
      </Typography>
      <Stack spacing={0}>
        {events.map((event, index) => (
          <Stack key={event.id} direction="row" spacing={1.25}>
            <Stack alignItems="center" sx={{ width: 22, flexShrink: 0 }}>
              <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', mt: 0.7 }} />
              {index < events.length - 1 && <Box sx={{ width: 1, flex: 1, bgcolor: 'divider', my: 0.5 }} />}
            </Stack>
            <Box sx={{ pb: index < events.length - 1 ? 1.5 : 0 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                {event.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {[formatDate(event.date), event.description].filter(Boolean).join(' - ')}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
